import React from 'react'

const Test2 = () => {
  return (
    <div>Test2</div>
  )
}

export default Test2